// Helpers to mark/verify that the user completed a mood check today,
// keyed by the user's timezone. Stored in localStorage.

// Build a stable "today" key in a specific IANA TZ (e.g., "America/Chicago").
export function todayKeyInTZ(
    tz = (typeof Intl !== "undefined" &&
          Intl.DateTimeFormat().resolvedOptions().timeZone) || "America/Chicago"
  ) {
    try {
      // Convert "now" into that TZ (stable across DST).
      const localNow = new Date(new Date().toLocaleString("en-US", { timeZone: tz }));
      const y = localNow.getFullYear();
      const m = String(localNow.getMonth() + 1).padStart(2, "0");
      const d = String(localNow.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    } catch {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      const d = String(now.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
  }
  
  function keyFor(tz) {
    return `moodcheck:${tz}:${todayKeyInTZ(tz)}`;
  }
  
  // Mark that the user checked in today.
  export function markMoodCheckedToday(tz) {
    try {
      const k = keyFor(tz);
      localStorage.setItem(k, "1");
      localStorage.setItem("moodcheck:last_tz", tz || "");
      localStorage.setItem("moodcheck:last_key", k);
    } catch {
      /* ignore storage failures */
    }
  }
  
  // Alias used by other files (same behavior, nicer name).
  export function setLocalMoodCheckedNow(tz) {
    markMoodCheckedToday(tz);
  }
  
  // Has the user already checked in today (in this TZ)?
  export function hasLocalMoodCheckedToday(tz) {
    try {
      return localStorage.getItem(keyFor(tz)) === "1";
    } catch {
      return false;
    }
  }

  // ===== WEEKLY HELPERS =====
  // Get Monday date key in user's timezone: YYYY-MM-DD (Monday)
  export function getMoodWeekKey(tz) {
    try {
      const zonedNow = new Date(new Date().toLocaleString("en-US", { timeZone: tz }));
      const day = zonedNow.getDay(); // 0=Sun..6=Sat
      const diffToMonday = (day + 6) % 7; // Mon=0, Sun=6
      const monday = new Date(zonedNow);
      monday.setHours(0, 0, 0, 0);
      monday.setDate(monday.getDate() - diffToMonday);
      const y = monday.getFullYear();
      const m = String(monday.getMonth() + 1).padStart(2, "0");
      const d = String(monday.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    } catch {
      // Fallback to today if timezone parsing fails
      const now = new Date();
      const day = now.getDay();
      const diffToMonday = (day + 6) % 7;
      const monday = new Date(now);
      monday.setHours(0, 0, 0, 0);
      monday.setDate(monday.getDate() - diffToMonday);
      const y = monday.getFullYear();
      const m = String(monday.getMonth() + 1).padStart(2, "0");
      const d = String(monday.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
  }

  // Has the user already checked in this week (in this TZ)?
  export function hasLocalMoodCheckedThisWeek(tz) {
    try {
      const key = `bp_mood_checked_week_key_${tz}`;
      return localStorage.getItem(key) === getMoodWeekKey(tz);
    } catch {
      return false;
    }
  }

  // Mark that the user checked in this week.
  export function markMoodCheckedThisWeek(tz) {
    try {
      const key = `bp_mood_checked_week_key_${tz}`;
      localStorage.setItem(key, getMoodWeekKey(tz));
    } catch {
      /* ignore storage failures */
    }
  }
  